export default "__VITE_ASSET__CetjVCFx__"